module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoUltBlkIt.834e541f.otf";